import { useBEMClasses } from "@circle-react/hooks/utils/useBEMClasses";
import classnames from "classnames";
import type { ReactNode } from "react";

export interface RowContainerProps {
  [key: string]: unknown;
  children?: ReactNode;
  className?: string;
  full?: boolean;
  inline?: boolean;
  lg?: boolean;
  md?: boolean;
  xl?: boolean;
}

export const RowContainer = ({
  children,
  className = "",
  ...props
}: RowContainerProps) => {
  const blockElement = "skeleton-loader__row-container";
  const { modifiers } = useBEMClasses(blockElement, props);

  return (
    <div className={classnames(blockElement, modifiers, className)}>
      {children}
    </div>
  );
};
